package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.lightened
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val DeleteButtonStyle = CssStyle {
    base {
        Modifier
            .size(35.px)
            .border(1.px, LineStyle.Solid, Colors.Primary)
    }
    Breakpoint.MD {
        Modifier.size(45.px)
    }
    hover {
        Modifier.border(1.px, LineStyle.Solid, Colors.BlueLight)
    }
}

val DeleteButtonIconStyle = CssStyle {
    base {
        Modifier.fontSize(22.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(30.px)
    }
}

val CompleteButtonStyle = CssStyle {
    base {
        Modifier
            .padding(leftRight = 10.px, topBottom = 7.px)
            .backgroundColor(Colors.LighterBlue)
            .transition {
                property("background-color")
                duration(200.ms)
            }
    }
    Breakpoint.MD {
        Modifier.padding(leftRight = 15.px, topBottom = 10.px)
    }
    hover {
        Modifier.backgroundColor(Colors.LighterBlue.lightened(0.2f))
    }
}

val CompleteButtonIconStyle = CssStyle {
    base {
        Modifier.fontSize(18.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(25.px)
    }
}

val CompleteButtonTextStyle = CssStyle {
    base {
        Modifier.fontSize(14.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(18.px)
    }
}